<template lang="html">

    <section class="registro">

        <encabezado :data="'generarNuevoConvenio'"></encabezado>
        <form class="form row-start ais container">
            <div class="contenedor-boton -relleno-data row-start">
                <a @click="requestUltimoConvenio" class="btn -solid-primary">Rellenar datos</a>
                <popup-info :texto="'ultimoconvenio'" :side="'right'"></popup-info>
            </div>
            <p class="contenedor-input">
                <strong>
                    Por favor, cumplimente los siguientes datos para generar el Convenio de Cooperación Educativa entre
                    su empresa y nuestro centro.
                </strong>
            </p>
        
            <div class="contenedor-input type-text full-slot " :class="[{ 'has-error': errors.has('centroTrabajo') }]">
                <centroTrabajo @setSucursal="setSucursal" :idSucursal="this.data.idCentroTrabajo"
                    :centrosTrabajoEmpresa="centrosTrabajoEmpresa" v-validate="'required'" data-vv-name="centroTrabajo"
                    v-model="data.idCentroTrabajo">
                </centroTrabajo>
                <span class='error' v-if="errors.first('centroTrabajo')">{{ errors.first('centroTrabajo') }}</span>
            </div>
            <h2 class="epigrafe">Datos del firmante</h2>
            <div class="contenedor-input type-text middle-slot">
                <label for="Nombre firmante">{{ $t('registro.firmante.nombre') }}*</label>
                <input type="text" name="nombre_firmante" v-validate="'required|min:3'" v-model="data.firmante.nombre">
                <span class='error' v-if="errors.first('nombre_firmante')">{{ errors.first('nombre_firmante') }}</span>
            </div>

            <div class="contenedor-input type-text middle-slot">
                <label for="apellidos firmante">{{ $t('registro.firmante.apellidos') }}*</label>
                <input type="text" name="apellidos_firmante" v-validate="'required|min:3'"
                    v-model="data.firmante.apellidos">
                <span class='error' v-if="errors.first('apellidos_firmante')">{{ errors.first('apellidos_firmante')
                    }}</span>
            </div>
            <div class="contenedor-input type-text middle-slot">
                <label for="DNI firmante">{{ $t('registro.firmante.dni') }}*</label>
                <input type="text" name="dni_firmante" v-model="data.firmante.dni" v-validate="'required|min:9'">
                <span class='error' v-if="errors.first('dni_firmante')">{{ errors.first('dni_firmante') }}</span>
            </div>
            <div class="contenedor-input type-text middle-slot">
                <label for="Cargo firmante">{{ $t('registro.firmante.cargo') }}*</label>
                <input type="text" name="cargo_firmante" v-model="data.firmante.cargo" v-validate="'required|min:3'">
                <span class='error' v-if="errors.first('cargo_firmante')">{{ errors.first('cargo_firmante') }}</span>
            </div>
            <div class="contenedor-input type-text middle-slot">
                <label for="email firmante">{{ $t('registro.firmante.email') }}*</label>
                <input type="text" name="email_firmante" v-validate="'required|email'" v-model="data.firmante.email">
                <span class='error' v-if="errors.first('email_firmante')">{{ errors.first('email_firmante') }}</span>
            </div>

            <div class="contenedor-input type-text middle-slot">
                <label for="notario_firmante">Poder Notarial que autoriza al firmante:</label>
                <input type="text" name="notario_firmante" v-model="data.firmante.poderNotarial" v-validate="'min:3'"
                    placeholder="Ej. Administrador en escritura de constitución">
                <span class='error' v-if="errors.first('notario_firmante')">{{ errors.first('notario_firmante')
                    }}</span>
            </div>
            <div class="contenedor-input three-slot">
                <input type="checkbox" name="politica" id="politica" v-validate="'required'">
                <label for="politica">Declaro expresamente que son ciertos los datos aportados por la entidad en su
                    solicitud de Convenio de colaboración educativa.</label>
                <span class='error' v-if="errors.first('politica')">{{ errors.first('politica') }}</span>
            </div>


            <div class="contenedor-boton">
                <a @click="validate" :loading="loadingbtn" class="btn -solid-primary">Solicitar convenio</a>
            </div>



        </form>

        <!-- <loading v-else></loading> -->




    </section>

</template>

<script lang="js">

import encabezado from '@/components/parts/encabezado';

import arrowLink from '@/components/parts/icons/arrow-link'

import { mapGetters, mapActions } from 'vuex';

import toggle from '@/components/parts/form/toggle'

import addIcon from '@/components/parts/icons/add'

import Datepicker from 'vuejs-datepicker';

import { ca, es } from 'vuejs-datepicker/dist/locale';

import popupInfo from '@/components/parts/popup-info';

import loading from '@/components/parts/loading';

import axios from 'axios'


import addContacto from '@/components/views/documentacion/addContacto'
import addCuentaFacturacion from '@/components/views/documentacion/addCuentaFacturacion'


import router from '@/router';

import Vue from 'vue';
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import { Validator } from 'vee-validate';

import confirmPopUp from '@/components/parts/confirm-popup';
import centroTrabajo from '@/components/parts/form/centro-trabajo';


Validator.extend('checkdni', {
    validate: value => {
        var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
        var nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
        var nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
        var str = value.toString().toUpperCase();

        if (!nifRexp.test(str) && !nieRexp.test(str)) return false;

        var nie = str
            .replace(/^[X]/, '0')
            .replace(/^[Y]/, '1')
            .replace(/^[Z]/, '2');

        var letter = str.substr(-1);
        var charIndex = parseInt(nie.substr(0, 8)) % 23;

        if (validChars.charAt(charIndex) === letter) return true;

        return false;
    },
    getMessage: field => 'El campo DNI está mal formado',
});


export default {
    name: 'solicitud-cambio-practica',
    mounted() {



    },
    data() {
        return {
            clicked: false,
            loading: false,
            loadingbtn: false,
            es: es,
            ca: ca,
            centroTrabajoSelected: null,
            data: {
                idCentroTrabajo: null,
                firmante: {
                    "nombre": "",
                    "apellidos": "",
                    "dni": "",
                    "cargo": "",
                    "email": "",
                    "poderNotarial": ""
                }
            },
            showpopup: false

        }
    },
    computed: {
        ...mapGetters({
            dominios: 'getDominios',
            dominiosOrder: 'getDominiosOrder',
            brand: 'getBrand',
            tiposContacto: 'getTipoContactoEmpresa',
            paises: 'getPaises',
            provincias: 'getProvincias',
            centrosTrabajoEmpresa: 'getcentrosTrabajoEmpresa',
            provinciasComplet: 'getProvinciasComplet',
            datosEmpresa: 'getDatosEmpresa'
        }),
    },
    methods: {
        ...mapActions(['addConvenioEmpresa']),
        setSucursal(data) {
            if (data) {
                console.log(data);
                this.data.idCentroTrabajo = data.idCentro
                console.log(this.data.idCentroTrabajo);
            } else {
                this.data.idCentroTrabajo = null;
                this.centroTrabajoSelected = null;
            }
        },
        requestUltimoConvenio() {
            axios.get(`/api/Empresa/dameDetalleUltimoConvenioEmpresa`).then(r => {
                if (r.data.status == 0) {
                    this.data = r.data.datos;
                    this.data.idCentroTrabajo = this.data.idCentroTrabajo;
                }
            }).catch(error => {
                commit('setError', 500);
                dispatch('sendErrorServer', error.response);
            });
        },
        addedContact() {
            this.newuser.show = false;
            this.requestContactos();
        },

        validate() {
            this.clicked = true;
            this.$validator.validateAll()
                .then(itsOk => {
                    if (itsOk) {
                        this.clicked = false;
                        this.sendData()


                    } else {
                        $('html,body').animate({ scrollTop: $("*[aria-invalid=true").offset().top - 150 }, 400);
                    }

                });
        },
        sendData() {
            this.loading = true;
            this.addConvenioEmpresa(this.data).then(r => {
                this.loading = false;
                if (r) {
                    this.showpopup = false;
                }
            });
        },

    },
    components: {
        'encabezado': encabezado,
        'arrow-link': arrowLink,
        'toggle': toggle,
        'add-icon': addIcon,
        Datepicker,
        'popup-info': popupInfo,
        'loading': loading,
        'add-contacto': addContacto,
        'add-cuenta-facturacion': addCuentaFacturacion,
        'confirm-popup': confirmPopUp,
        'centroTrabajo': centroTrabajo,
    }
}



</script>

<style scoped lang="scss">
form {
    padding-top: 50px;
}

.epigrafe {
    margin-bottom: 20px;
}

.contenedor-boton {
    margin-top: 0px;
    padding-left: 30px;
    width: 100%;
    margin-bottom: 30px;

    &.-relleno-data {
        width: auto;
        display: inline-block;
        position: relative;
        padding-right: 30px;

        .popup-info {
            right: 0;
        }
    }
}

.form .with-toggle {
    width: 100%;
    margin-bottom: 30px;


    .contenedor-toogle {
        position: relative;
        right: auto;
        top: auto;
    }

    &.fecha {
        width: 33.33333333%;
        margin-bottom: 0;
        padding-bottom: 0;

        .contenedor-toogle {
            position: absolute;
            right: 0px;
            top: 0px;
        }
    }
}

.-forma-pago {
    margin-bottom: 5px;
}

.-iban label {
    width: 100%;
}

.-iban input {
    width: auto;
    letter-spacing: 1px;
}

.-iban span {
    margin: 0 5px;

    &:last-of-type {
        display: none;
    }
}

.contenedor-iban {
    flex-wrap: nowrap;
}

.-iban input[campos=n-2] {
    width: calc(12px * 2);
}

.-iban input[campos=n-4] {
    width: calc(12px * 4);
}

.-iban input[campos=n-10] {
    width: calc(12px * 10);
}

.legal-info {
    max-width: 800px;
    padding-left: 30px;
    margin-top: 20px;

    h2 {
        text-align: left;
        font-size: 15px;
        margin-bottom: 10px;
        font-weight: bold;
    }

    p {
        font-size: 13px;
        margin-bottom: 0px;
    }
}

.contenedor-input input[type="checkbox"]+label {
    line-height: 1.2em;

    &:before {
        top: 10px;
    }
}

@media screen and (max-width: 900px) {
    .contenedor-boton {
        padding-left: 0px;
        margin-top: 30px;
    }

    .add-link {
        margin-left: 0;
    }


    .legal-info {
        padding-left: 0;
    }

    .form .with-toggle.fecha {
        width: 100%;
    }

}

@media screen and (max-width: 340px) {
    .form .with-toggle.fecha strong {
        font-size: 14px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/views/documentacion/generar-nuevo-convenio.vue